<template>
  <div style="min-height: 750px;" @click="d_newSupportMessage = false">
    <template v-if="d_userSupportClientID || d_mailSupportClientID">
      <b-row style="margin: 3px;">
        <b-col cols="12">
          <b-button v-if="d_newSupportMessage" style="background-color: #ff4d4f;; color: white; float: right; border-radius: 15px 0px; border: 1px solid #ff4d4f;; padding: 4px 10px;">
            {{ StoreLangTranslation.data['new_message'][StoreLang] }}
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols=12>
          <support-detail :p_userSupportClientID="d_userSupportClientID" :p_mailSupportClientID="d_mailSupportClientID" :p_newMessage="d_newSupportMessage" @changeNewMessage="d_newSupportMessage = $event" :p_supportType="d_supportType"></support-detail>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </template>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import moment from "moment";
import { mapGetters } from 'vuex';
import {
  default as SupportDetail
} from '@/wam/components/widgets/SupportDetail';
export default {
  name: 'user_support_details',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreDevice: 'StoreDevice',
  }),
  components: {
    SupportDetail,
  },
  props: {},
  data () {
    return {
      d_userSupportClientID: '',
      d_mailSupportClientID: '',
      d_newSupportMessage: false,
      d_supportType: '',
    };
  },
  created: function () {},
  beforeMount () {},
  mounted: function () {
    if (this.$route.query.user_support_client_id) {
      this.d_userSupportClientID = this.$route.query.user_support_client_id;
      this.d_supportType = 'user';
    } else if (this.$route.query.mail_support_client_id) {
      this.d_mailSupportClientID = this.$route.query.mail_support_client_id;
      this.d_supportType = 'mail';
    }
  },
  methods: {}
};

</script>

